import { Dispatch, SetStateAction } from 'react';
import { List, ListItemButton } from '@mui/material';
import ScrollingContainer from 'components/ScrollingContainer';
import useDeviceScreen from 'lib/hooks/useDeviceScreen';
import { useWindowSize } from 'react-use';
import { colors } from 'components/styles/variables';
import { useStyles } from './styles';

interface CheckMenuListProps {
  options: string[];
  selected?: string;
  onSelect?: (selected: string) => void;
  setIsModalOpen?: Dispatch<SetStateAction<boolean>>;
}

export default function CheckMenuList({
  options,
  selected,
  onSelect,
  setIsModalOpen,
}: CheckMenuListProps): JSX.Element {
  const classes = useStyles();
  const { height: windowHeight } = useWindowSize();
  const { isMobile } = useDeviceScreen();
  const scrollingContainerHeight = isMobile ? windowHeight : undefined;

  return (
    <ScrollingContainer className={classes.scrollingContainer} height={scrollingContainerHeight}>
      <List className={classes.radiusModal}>
        {options.map((option, index) => {
          const isSelected = selected === option;
          return (
            <ListItemButton
              className={classes.listItem}
              key={index}
              onClick={(): void => {
                onSelect?.(option);
                setIsModalOpen?.(false);
              }}
              selected={isSelected}
              classes={{ selected: classes.selected }}
              style={{ padding: '12px 24px', backgroundColor: colors.WHITE }}
            >
              {isSelected && <div className={classes.selectedIcon} />}
              {option}
            </ListItemButton>
          );
        })}
      </List>
    </ScrollingContainer>
  );
}
